"use client"

import useView, { Entity } from "@/app/hooks/useView"
import { useEffect } from "react"

export default function RecordView({ entity, id }: {
    entity: Entity,
    id: number
}) {
    const { sendView } = useView(entity, id)
    useEffect(() => {
        sendView()
    }, [id])
    return <></>
}